import { render, staticRenderFns } from "./TktzSendMsgHistory.vue?vue&type=template&id=213da8d0&scoped=true"
import script from "./TktzSendMsgHistory.vue?vue&type=script&lang=js"
export * from "./TktzSendMsgHistory.vue?vue&type=script&lang=js"
import style0 from "./TktzSendMsgHistory.vue?vue&type=style&index=0&id=213da8d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213da8d0",
  null
  
)

export default component.exports